import Dossier, { AppointmentData } from '@/dossier/models/Dossier';
import User from '@/shared/models/User';
import DossierDetails from './DossierDetails';

export default class PlannerDossierAdapter extends Dossier {
  constructor(readonly dossierDetails: DossierDetails, dossier: Dossier) {
    super();
    Object.assign(this, dossier);
  }

  updateAppointment(data: AppointmentData, user: User): void {
    super.updateAppointment(data, user);
    this.dossierDetails.preferredPickUp = this.preferredPickUpOn;
    this.dossierDetails.waitsOnPremise = this.waitsOnPremise;
    this.dossierDetails.mobilitySolutionDescription = this.mobilitySolution?.description ?? '';
  }
}